import { put, call, takeLatest, all } from "redux-saga/effects"
import { appName } from "../constants"
import { postAddRule } from "../api/lt-api"
import { toastr } from "react-redux-toastr"

/**
 * Constants
 **/
export const moduleName = "selector"
const prefix = `${appName}/${moduleName}`

const ADD_RULE_REQUEST = `${prefix}/ADD_RULE_REQUEST`
const ADD_RULE_REQUEST_SUCCESSFUL = `${prefix}/ADD_RULE_REQUEST_SUCCESSFUL`
const ADD_RULE_REQUEST_FAILURE = `${prefix}/ADD_RULE_REQUEST_FAILURE`

/**
 * Reducer
 **/
const initialState = {
  data: []
}

export default function reducer(state = initialState, { type, rule }) {
  switch (type) {
    case ADD_RULE_REQUEST_SUCCESSFUL:
      return {
        ...state,
        data: rule
      }

    default:
      return state
  }
}

/**
 * Selectors
 **/

/**
 * Action Creators
 **/
export function getAddRuleRequest(data) {
  return {
    type: ADD_RULE_REQUEST,
    payload: { data }
  }
}

/**
 * Sagas
 **/
function* getAddRuleRequestSaga({ payload: { data } }) {
  try {
    const rule = yield call(postAddRule, data)
    yield put({
      type: ADD_RULE_REQUEST_SUCCESSFUL,
      rule
    })
    const toastrSuccess = toastr.success
    yield call(toastrSuccess, "Rule added")
  } catch (error) {
    const toastrError = toastr.error
    yield call(toastrError, error.message)
    yield put({ type: ADD_RULE_REQUEST_FAILURE })
  }
}

export function* saga() {
  yield all([takeLatest(ADD_RULE_REQUEST, getAddRuleRequestSaga)])
}
